export const REQUIREMENT_MODAL_ID = 'requirement-modal'
